import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { XpressCenterService } from 'app/services';
import { Utils } from 'app/utils';
import moment from 'moment';

@Component({
  selector: 'driver-center-create',
  templateUrl: './driver-center-create.component.html',
  styleUrls: ['./driver-center-create.component.scss'],
  providers: [MessageService]
})

export class DriverCenterCreateComponent {
  @Input()
  public showPopup: boolean = false;

  @Input()
  public onHide: () => void = () => { };

  constructor(
    private messageService: MessageService,
    private xpressCenterService: XpressCenterService
  ) { }

  public loading: boolean = false;

  public xpressCenter: any = {};

  public handleSideBarHide() {
    this.onHide();
    this.xpressCenter = {};
  }

  public createXpressCenter() {
    this.loading = true;
    const dto = {
      Name: this.xpressCenter.Name,
      Address: this.xpressCenter.Address,
      City: this.xpressCenter.City,
      ContractStartedAt: moment(this.xpressCenter.StartedAt).format('YYYY-MM-DD'),
      ContractEndedAt: moment(this.xpressCenter.EndedAt).format('YYYY-MM-DD'),
      MonthlyRent: this.xpressCenter.MonthlyRent,
      CusaFee: this.xpressCenter.CusaFee,
      ImageUrl: this.xpressCenter.ImageUrl,
      TimeZoneOffSet: Utils.getTimezoneOffset(),
      CreatedAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss')
    };
    if (!dto.Name || !dto.Address || !dto.City || !dto.ContractEndedAt || !dto.ContractStartedAt || !dto.MonthlyRent || !dto.CusaFee) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not all fields are filled' });
      this.loading = false;
      return;
    }
    this.xpressCenterService.createXpressCenter(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Center has been added' });
        this.handleSideBarHide();
        this.xpressCenter = {};
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public handleInputChange(e: any) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const pattern = /image-*/;
    const reader = new FileReader();
    if (!file.type.match(pattern)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid format. Please select Image' });
      return;
    }
    reader.onload = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  private handleReaderLoaded(e: any) {
    const reader = e.target;
    this.xpressCenter.ImageUrl = reader.result;
  }
}
